import dayjs from "dayjs";

export const METRICS_DATE_RANGE_OPTIONS = [
  { value: "30d", label: "Last 30 days" },
  { value: "3m", label: "Last 3 months" },
  { value: "6m", label: "Last 6 months" },
  { value: "12m", label: "Last 12 months" },
  { value: "all", label: "All time" },
] as const;

export type MetricsDateRange = (typeof METRICS_DATE_RANGE_OPTIONS)[number]["value"];

export const DEFAULT_METRICS_DATE_RANGE: MetricsDateRange = "12m";

export function getMetricsSinceDate(range: MetricsDateRange): string {
  if (range === "all") {
    return "1970-01-01T00:00:00.000Z";
  }

  const now = dayjs();

  switch (range) {
    case "30d":
      return now.subtract(30, "day").startOf("day").toISOString();
    case "3m":
      return now.subtract(3, "month").startOf("day").toISOString();
    case "6m":
      return now.subtract(6, "month").startOf("day").toISOString();
    case "12m":
      return now.subtract(12, "month").startOf("day").toISOString();
    default:
      return now.subtract(3, "month").startOf("day").toISOString();
  }
}

export function getMetricsDateRangeLabel(range: MetricsDateRange): string {
  return (
    METRICS_DATE_RANGE_OPTIONS.find((option) => option.value === range)?.label ??
    "Last 12 months"
  );
}
